import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'

import generalSelectors from 'models/General/selectors'
import authSelectors from 'models/Authentication/selectors'
import authActions from 'models/Authentication/actions'
import profileInfoSelectors from 'models/ProfileInfo/selectors'

import { APP_URLS } from 'resources/urls'

import useSignInRedirect from 'hooks/useSignInRedirect'

export const WHITELISTED_UNVEIL_PATHS = [APP_URLS.FULL_UNVEIL, APP_URLS.SUBSCRIPTION]

const RoutesHandler = ({ children = null }) => {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()

  const [handleSignInRedirect, resetIsHandled] = useSignInRedirect()

  const isAppInitialized = useSelector(generalSelectors.getIsAppInitialized)
  const isAuthenticatedRoute = useSelector(generalSelectors.getIsAuthenticatedRoute)
  const isAuthenticated = useSelector(authSelectors.getIsAuthenticated)

  const isLockedByAdmin = useSelector(profileInfoSelectors.getIsLockedByAdmin)
  const isUnveilOnboarded = useSelector(profileInfoSelectors.getIsUnveilOnboarded)

  // Check isAuthenticated on every route change without blocking the navigation
  useEffect(() => {
    if (!isAppInitialized || !isAuthenticatedRoute) {
      return
    }
    dispatch(authActions.checkIsAuthenticated.init())
  }, [dispatch, isAppInitialized, isAuthenticatedRoute, isAuthenticated, location.pathname])

  useEffect(() => {
    if (!isAppInitialized || !isAuthenticatedRoute || !isAuthenticated) {
      return
    }

    // Authenticated Routes' global redirects
    if (isLockedByAdmin && location.pathname !== APP_URLS.LOCKED) {
      // Locked screen
      history.replace(APP_URLS.LOCKED)
    }
  }, [
    history,
    isAppInitialized,
    isAuthenticatedRoute,
    isAuthenticated,
    location.pathname,
    isLockedByAdmin,
    isUnveilOnboarded,
    handleSignInRedirect,
  ])

  useEffect(() => resetIsHandled(), [location.pathname, resetIsHandled])

  return children
}

RoutesHandler.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
}

export default RoutesHandler
